exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-tick {\n  border: 1px solid #d1d1d1;\n  border-radius: 50%;\n  height: 26px;\n  position: relative;\n  width: 26px;\n}\n.icon-tick.focused {\n  box-shadow: 0 0 0 3.2px rgba(241, 90, 41, 0.25);\n}\n.icon-tick.checked {\n  background: #00abbe;\n  border: 0;\n}\n.icon-tick svg {\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 13px;\n}", ""]);

// exports
